import { Link } from "react-router-dom";

interface ArticleCardProps {
  id: string;
  title: string;
  summary: string;
  coverImage: string;
  author: string;
  publishDate: string;
  views: number;
  category: string;
  categorySlug: string;
  tags: string[];
}

function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toString();
}

export default function ArticleCard({
  id,
  title,
  summary,
  coverImage,
  author,
  publishDate,
  views,
  category,
  categorySlug,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all duration-300">
      <Link to={`/article/${id}`} className="block cursor-pointer">
        <div className="aspect-[2/1] overflow-hidden bg-background-200">
          <img
            src={coverImage}
            alt={title}
            title={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            width="640"
            height="320"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer"
          >
            {category}
          </Link>
          <span className="text-xs text-foreground-400">{publishDate}</span>
        </div>
        <Link to={`/article/${id}`} className="block cursor-pointer">
          <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
          {summary}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1 flex-wrap">
            {tags.slice(0, 2).map((tag, idx) => (
              <span
                key={idx}
                className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded"
              >
                {tag}
              </span>
            ))}
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(views)}阅读
            </span>
            <span>{author}</span>
          </div>
        </div>
      </div>
    </article>
  );
}